import React from 'react';
import styles from './Checkbox.scss';

export default function Checkbox(props) {
  return (
    <label className={styles.root}>
      <input
        {...props}
        type="checkbox" />
      <div className={styles.pseudoCheckbox} />
      <span
        dangerouslySetInnerHTML={{ __html: props.text }} />
    </label>
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/Checkbox/Checkbox.jsx
 **/